var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 13.123C13.5971 13.123 14.892 11.8281 14.892 10.2307C14.892 8.63331 13.5971 7.33838 11.9997 7.33838C10.4024 7.33838 9.10742 8.63331 9.10742 10.2307C9.10742 11.8281 10.4024 13.123 11.9997 13.123Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2306 10.2308C19.2306 16.7385 11.9998 21.8 11.9998 21.8C11.9998 21.8 4.76904 16.7385 4.76904 10.2308C4.76904 8.31305 5.53085 6.47388 6.88689 5.11784C8.24292 3.76181 10.0821 3 11.9998 3C13.9175 3 15.7567 3.76181 17.1127 5.11784C18.4688 6.47388 19.2306 8.31305 19.2306 10.2308V10.2308Z",
    stroke: "#020617",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocationPin);
export default __webpack_public_path__ + "static/media/icon-location-pin.0c6898801183f3cfd224bdaf685138c5.svg";
export { ForwardRef as ReactComponent };